import clsx from 'clsx';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../slices/store';
import { EStages } from '../../../utils/types';
import { StyledStagesBreadcrumbs } from './styles';

export const StagesBreadcrumbs = () => {
  const { t } = useTranslation();
  const translationPrefix = 'header.stages';

  const { stage } = useAppSelector((s) => s.mainStore);

  return (
    <StyledStagesBreadcrumbs>
      <div className={clsx('stage', { active: !stage || stage === EStages.lobby })}>
        {t(`${translationPrefix}.lobby`)}
      </div>
      {'>'}
      <div className={clsx('stage', { active: stage === EStages.add_songs })}>
        {t(`${translationPrefix}.add_songs`)}
      </div>
      {'>'}
      <div className={clsx('stage', { active: [EStages.vote, EStages.results].includes(stage as EStages) })}>
        {t(`${translationPrefix}.vote`)}
      </div>
    </StyledStagesBreadcrumbs>
  )
}
